/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiWebhookSigningKeyFromJSON, StreemApiWebhookSigningKeyToJSON, } from './';
export function StreemApiUpdateSigningKeyResponseFromJSON(json) {
    return StreemApiUpdateSigningKeyResponseFromJSONTyped(json, false);
}
export function StreemApiUpdateSigningKeyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'signingKey': !exists(json, 'signing_key') ? undefined : StreemApiWebhookSigningKeyFromJSON(json['signing_key']),
    };
}
export function StreemApiUpdateSigningKeyResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'signing_key': StreemApiWebhookSigningKeyToJSON(value.signingKey),
    };
}
//# sourceMappingURL=StreemApiUpdateSigningKeyResponse.js.map